import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../logo.png";
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <span className="logo-icon">
            <img
              src={logo}
              alt="nextversion AI Logo"
              style={{
                width: "240px",
                height: "65px",
                objectFit: "contain",
              }}
            />
          </span>
          {/*<h2>nextversion AI</h2>*/}
          <p className="auth-subtitle">Your AI Chat Interface</p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p className="auth-switch">
          Don't have an account? <Link to="/register">Sign Up</Link>
        </p>
      </div>
      <footer className="auth-footer">
        <small className="disclaimer">
          © 2026 NextVersion AI. Created by{" "}
          <a
            href="https://nimahabibi.de"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--primary-color)" }}
          >
            Nima Habibi
          </a>
          . All rights reserved.
        </small>
      </footer>
    </div>
  );
}
